import { Controller } from "@hotwired/stimulus"

// Manages chain relationship configuration in the relationship form
// Handles toggle between Direct Join and Chain Relationship modes
export default class extends Controller {
  static targets = [
    "directJoinTab",
    "chainTab",
    "modeField",
    "directJoinSection",
    "chainSection",
    "chainList",
    "relationshipSelect",
    "joinExpression"
  ]
  static values = { chain: Array }

  connect() {
    this.chain = this.chainValue || []
  }

  selectDirectJoin() {
    // Update tab appearance
    this.directJoinTabTarget.classList.add("tab-active")
    this.chainTabTarget.classList.remove("tab-active")

    // Show/hide sections
    this.directJoinSectionTarget.classList.remove("hidden")
    this.chainSectionTarget.classList.add("hidden")

    // Update mode field
    this.modeFieldTarget.value = "direct"

    // Clear the chain when switching to direct mode
    this.chain = []
    this.renderChain()
  }

  selectChain() {
    // Update tab appearance
    this.chainTabTarget.classList.add("tab-active")
    this.directJoinTabTarget.classList.remove("tab-active")

    // Show/hide sections
    this.chainSectionTarget.classList.remove("hidden")
    this.directJoinSectionTarget.classList.add("hidden")

    // Update mode field
    this.modeFieldTarget.value = "chain"

    // Clear join expression when switching to chain mode
    if (this.hasJoinExpressionTarget) {
      this.joinExpressionTarget.value = ""
    }
  }

  addToChain(event) {
    const select = event.target
    const value = select.value
    if (!value) return

    const option = select.selectedOptions[0]
    const targetLabel = option.dataset.targetLabel

    this.chain.push(value)
    this.renderChain()

    // Reset the select
    select.value = ""
  }

  removeFromChain(event) {
    const item = event.target.closest(".chain-item")
    const index = Array.from(this.chainListTarget.children).indexOf(item)

    if (index > -1) {
      this.chain.splice(index, 1)
      this.renderChain()
    }
  }

  renderChain() {
    const list = this.chainListTarget
    list.innerHTML = ""

    this.chain.forEach((relKey, idx) => {
      const div = document.createElement("div")
      div.className = "flex items-center gap-2 chain-item"
      div.innerHTML = `
        <span class="badge badge-sm badge-outline">${idx + 1}</span>
        <input type="hidden" name="report_data_relationship[relationship_chain][]" value="${relKey}">
        <span class="font-mono text-sm">${relKey}</span>
        <button type="button" class="btn btn-ghost btn-xs" data-action="click->chain-relationship#removeFromChain">
          <svg class="w-3 h-3" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <path d="M18 6L6 18M6 6l12 12"/>
          </svg>
        </button>
      `
      list.appendChild(div)
    })
  }
}
